// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rUH3SPBYO3Lfayj_gQ9S {
  flex-grow: 1;
  height: min-content !important;
  order: 2;
}

.Jm5uSuHTI1entD8u3lfR {
  flex-grow: 1;
  max-width: 768px;
  max-height: 100%;
  height: 242px !important;
  order: 1;
}

.Fp1W3bejlKbGkBcySGvH{
  cursor: pointer;
}

@media (min-width: 600px) {
  .rUH3SPBYO3Lfayj_gQ9S {
    order: 1;
  }

  .Jm5uSuHTI1entD8u3lfR {
    order: 2;
    height: 100% !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/MobileNumberLogin.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;EACxB,QAAQ;AACV;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;IACR,uBAAuB;EACzB;AACF","sourcesContent":[".login__form {\r\n  flex-grow: 1;\r\n  height: min-content !important;\r\n  order: 2;\r\n}\r\n\r\n.login__image {\r\n  flex-grow: 1;\r\n  max-width: 768px;\r\n  max-height: 100%;\r\n  height: 242px !important;\r\n  order: 1;\r\n}\r\n\r\n.btn__password{\r\n  cursor: pointer;\r\n}\r\n\r\n@media (min-width: 600px) {\r\n  .login__form {\r\n    order: 1;\r\n  }\r\n\r\n  .login__image {\r\n    order: 2;\r\n    height: 100% !important;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"login__form": `rUH3SPBYO3Lfayj_gQ9S`,
	"login__image": `Jm5uSuHTI1entD8u3lfR`,
	"btn__password": `Fp1W3bejlKbGkBcySGvH`
};
export default ___CSS_LOADER_EXPORT___;
